
        import instance from '../../infra/db/instance';
        import SubscriberModel  from './model';
        import { FormatterValidator } from '../../infra/adapters/formatterValidator'
       
        export default class useServicePut extends SubscriberModel {
        constructor() {
            super();
        }
        initValues() {
            return true
        }
       
        validation(args) {
            let res = FormatterValidator.formatAndValidate(args, this.initialValues)
            return res
        }
       
        formatting(args) {
            let res = FormatterValidator.formatting(args, this.initialValues)
            this.payload = res;
            return res
        }
       
        masking(args) {
            let res = FormatterValidator.masking(args, this.initialValues)
            this.payload = res;
            return res
        }
       
        async execute(action,args) {
            let config = { post: ["create", "post"], patch: ["patch", "PATCH"] }
            console.log("CLASS CREATE CONFIG: ", `/subscriber?method=${config[action][0]}`);
            const response = await instance({
            url: `/subscriber?method=${config[action][0]}`,
            method: `${config[action][1]}`,
            data: args
            }).catch(r=>{
                console.log("DEU ERRO",r);
               return r
            })
            console.log("responseresponseresponseresponse",response);
            return response
        }
       
        }
        